import { Delete } from "@mui/icons-material";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  useTheme
} from "@mui/material";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import React, { forwardRef, memo, useEffect, useImperativeHandle, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { useStyle } from "../style";

const BillingTable = forwardRef((props, ref) => {
  const theme = useTheme();
  const classes = useStyle();
  const {data, setData,code, setCode, setPostData, reset} = props
  const [itemData, setItemData] = useState(null)
  const[active, setActive] = useState(null)
  const [qty, setQty] = useState('')
  const dispatch = useDispatch()
  const [selectedRows, setSelectedRows] = useState([]);
  const [sumOutstanding, setSumOutstanding] = useState(0);
  const [sumRetQty, setSumRetQty] = useState(0);
  const[resultValue , setResultValue ] = useState(0)
  const [sumDifference, setSumDifference] = useState(0);
  const [editedQuantities, setEditedQuantities] = useState(new Array(data.length).fill(''));
  // const [rateData, setRateData] = useState({
  //   mrp : '',
  //   disc :'',
  //   rate :'',
  //   gst : '',
  // })
  
  const [editingIndex, setEditingIndex] = useState(null);
  // const [editedValues, setEditedValues] = useState({
  //   qty: "",
  // });
  const codeRef = useRef(null)
  const qtyRef = useRef(null)

  const priceRef = {
    mrp : useRef(null),
    gst : useRef(null),
    rate : useRef(null),
    disc : useRef(null),
  }

function checkRef(value){
  if(value=='mrp'){
    priceRef.gst.current.focus()
  }
  else if(value == 'gst'){
    priceRef.rate.current.focus()
  }
  else if(value == 'rate'){
    priceRef.disc.current.focus()
  }
  else if(value == 'disc'){
    qtyRef.current.focus()
  }
}
function checkUpdateRow(name, value){
  const arr=[...data]
  setData([])
  if(name==='gst'){
   arr[editingIndex].gstAmt = parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * arr[editingIndex].disc1 / 100) * (value / 100) * arr[editingIndex].qty).toFixed(2)
    setData(arr)
  }
  else if(name==='rate'){
    arr[editingIndex].rate1 = value
   arr[editingIndex].gstAmt = parseFloat((value - value * arr[editingIndex].disc1 / 100) * (arr[editingIndex].gst1 / 100) * arr[editingIndex].qty).toFixed(2)
   arr[editingIndex].totalAmt = parseFloat((value - value * arr[editingIndex].disc1 / 100)  * arr[editingIndex].qty).toFixed(2)
   arr[editingIndex].cessAmt= parseFloat((value - value * arr[editingIndex].disc1 / 100) * (arr[editingIndex].cess / 100) * arr[editingIndex].qty).toFixed(2)
    setData(arr)
  }
  else if(name==='disc'){
   arr[editingIndex].gstAmt = parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * parseFloat(value) / 100) * (arr[editingIndex].gst1 / 100) * arr[editingIndex].qty).toFixed(2)
   arr[editingIndex].totalAmt = parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 *  parseFloat(value) / 100)  * arr[editingIndex].qty).toFixed(2)
   arr[editingIndex].cessAmt= parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * parseFloat(value) / 100) * (arr[editingIndex].cess / 100) * arr[editingIndex].qty).toFixed(2)
    setData(arr)
  }
  else if(name==='qty'){
    arr[editingIndex].qty = value
   arr[editingIndex].gstAmt = parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * arr[editingIndex].disc1 / 100) * (arr[editingIndex].gst1 / 100) * value).toFixed(2)
   arr[editingIndex].totalAmt = parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * arr[editingIndex].disc1 / 100)  * value).toFixed(2)
   arr[editingIndex].cessAmt= parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * arr[editingIndex].disc1 / 100) * (arr[editingIndex].cess / 100) * value).toFixed(2)
    setData(arr)
  }
} 
function getSelectedRow(e){
  console.log(e)
  setActive(e)
  const arr=[...data]
} 
//  function checkUpdatedRef(value){
// if(value==='mrp'){
// updatedRef.gst.current.focus()
// }
// else if(value==='gst'){  
// updatedRef.rate.current.focus()
// }
// else if(value==='rate'){  
//   updatedRef.disc.current.focus()
//   }
//   else if(value==='disc'){  
//     updatedRef.qty.current.focus()
//     }
//   else if(value==='qty'){
// addToData()
//   }
//  }

console.log(data)
 function addToData(){
console.log(data)
codeRef.current.focus()
 }
//  function handleQtyChange(e) {
//   const arr = [...data];
//   const inputValue = e.target.value;
//     arr[active].retQty = inputValue;
   
//     console.log( arr[active].outstanding - inputValue, 'Ithu than difference')
//     setSumDifference(arr[active].outstanding - inputValue)
//     setData(arr);
  
// }
function handleQtyChange(e) {
  const inputValue = e.target.value.trim(); // Trim to remove leading and trailing whitespaces
  if (inputValue === '') {
    // If the input is empty, clear the input field
    setData(data.map((item, index) => {
      if (index === active) {
        return { ...item, retQty: '' };
      }
      return item;
    }));
    setSumDifference(data[active].outstanding);
  } else {
    const parsedValue = parseInt(inputValue);
    if (!isNaN(parsedValue)) { // Check if the entered value is a valid number
      const newQty = Math.min(parsedValue, data[active].outstanding); // Ensure the entered quantity does not exceed the outstanding amount
      const updatedData = data.map((item, index) => {
        if (index === active) {
          return { ...item, retQty: newQty };
        }
        return item;
      });
      setData(updatedData);
      setSumDifference(data[active].outstanding - newQty);
    } else {
      // Handle invalid input (e.g., show an error message)
      // Optionally, you can reset the input field to its previous value or set it to 0
      console.log("Invalid input");
    }
  }
}
console.log(sumDifference,'Enna difference!')
//  const handleQtyChange = (value) => {
//   if (parseFloat(value) <= parseFloat(data[editingIndex].outstanding)) {
//     setEditedValues((prev) => ({
//       ...prev,
//       qty: value,
//     }));
//   } else {
//     console.log("Error: Quantity cannot exceed outstanding value.");
//   }
// };
// const handleQtyChange = (value, rowIndex) => {
//   // Check if the entered quantity is less than or equal to the outstanding value
//   if (parseFloat(value) <= parseFloat(data[rowIndex].outstanding)) {
//     setEditedQuantities((prev) => {
//       const updatedQuantities = [...prev];
//       updatedQuantities[rowIndex] = value;
//       return updatedQuantities;
//     });
//   } else {
//     // Display an error message or take appropriate action if validation fails
//     console.log("Error: Quantity cannot exceed outstanding value.");
//     // Optionally, you can set an error state or show a snackbar message
//   }
// };
//  useImperativeHandle(ref, () => ({
//   focusCodeInput: () => {
//     setQty('')
//     setItemData(null)
//     setRateData((prevData) => ({ ...prevData, mrp: "", rate: "", gst : "", disc : "" }))
//     codeRef.current.focus()
//   }
// }));
// useEffect(() => {
// if(data.length > 0){
//   let arr=[]
//   data.map(val=>{
//     const obj = {
//       docdate:moment().format('YYYY/MM/DD'),
//       proid:val.pro_code,
//       dis_per:val.disc1,
//       dis_amt:parseFloat((val.rate1 -(val.rate1 * (100 - val.disc1 )/ 100)) * val.qty).toFixed(2),
//       mrp:val.mrp1,
//       rate:val.rate1,
//       qty:val.qty,
//       gst_per:val.gst1,
//       gst_amt:val.gstAmt,
//       cess_per:val.cess,
//       cess_amt:val.cessAmt,
//       barcode:  val.barcode,
//       head_id: val.head_id ,
//       type_id:  val.type ,
//       subcat_id:  val.sub_cat ,
//       cat_id:  val.cat_id ,
//       uom_id:  val.uom 
//     }
//     arr.push(obj)
//   })
//   setPostData((prevState)=>({...prevState, purchase_details: arr}))
// }
  
// },[data])

// useEffect(()=>{
// if(reset){
//   setData([])
//   setCode('')
//   setQty('')
//   setItemData(null)
//   setRateData((prevData) => ({ ...prevData, mrp: "", rate: "", gst : "", disc : "" }))
// }
// },[reset])
const handleCheckboxClick = (val ) => {
  console.log(val);
  const isSelected = selectedRows.some((selectedRow) => selectedRow.id === val.id);
  const updatedRows = isSelected
  ? selectedRows.filter((selectedRow) => selectedRow.id !== val.id)
  : [...selectedRows, val];
setSelectedRows(updatedRows);
// const updatedData = data.map((row) => {
//   if (row.id === val.id) {
//     return {
//       ...row,
//       retQty: parseFloat(val.outstanding).toFixed(2),
//     };
//   }
//   return row;
// });

// setData(updatedData);
//sum of outstanding and sum of retQty
const sumOutstanding = updatedRows.reduce((acc, selectedRow) => acc + parseFloat(selectedRow.outstanding), 0);
    const sumRetQty = updatedRows.reduce((acc, selectedRow) => acc + parseFloat(selectedRow.retQty || 0), 0);

    // Calculate the difference and store it in the state
    const difference = sumOutstanding - sumRetQty;
    console.log(difference,'Enna Difference!')
    setSumDifference(difference);
    setSumRetQty(sumRetQty);
};
// const handleCheckboxClick = (val) => {
//   const isSelected = selectedRows.some((selectedRow) => selectedRow.id === val.id);
//   let updatedRows;

//   if (isSelected) {
//     // If the checkbox is already checked, uncheck it
//     updatedRows = selectedRows.filter((selectedRow) => selectedRow.id !== val.id);
//   } else {
//     // If the checkbox is not checked, check it and set retQty to outstanding
//     updatedRows = [...selectedRows, val];

//     // Set the default retQty value to the outstanding amount when the checkbox is clicked
//     const updatedData = data.map((row) => {
//       if (row.id === val.id) {
//         const retQtyValue = parseFloat(val.outstanding).toFixed(2);
//         return {
//           ...row,
//           retQty: retQtyValue <= parseFloat(row.outstanding) ? retQtyValue : parseFloat(row.outstanding).toFixed(2),
//         };
//       }
//       return row;
//     });

//     setData(updatedData);
//   }

//   setSelectedRows(updatedRows);

//   //sum of outstanding and sum of retQty
//   const sumOutstanding = updatedRows.reduce((acc, selectedRow) => acc + parseFloat(selectedRow.outstanding), 0);
//   const sumRetQty = updatedRows.reduce((acc, selectedRow) => acc + parseFloat(selectedRow.retQty || 0), 0);

//   // Calculate the difference and store it in the state
//   const difference = sumOutstanding - sumRetQty;
//   setSumDifference(difference);
//   setSumRetQty(sumRetQty);
// };
useEffect(() => {
  if (data.length > 0) {
    const totalOutstanding = data.reduce((acc, val) => acc + parseFloat(val.outstanding), 0);
    const totalRetQty = data.reduce((acc, val) => acc + parseFloat(val.retQty || 0), 0);
    const result = totalOutstanding - totalRetQty;
    setSumOutstanding(totalOutstanding);
    setSumRetQty(totalRetQty);
    setResultValue(result)
    console.log("Result:", result);
  }
}, [data]);
useEffect(() => {
  if(data.length > 0){
    let arr = []
    data.filter(value=>value.retQty > 0).map(val => {
      const obj = {
        invoice_no: val.docno,
        date: moment(val.docdate).format("YYYY-MM-DD"),
        amount: parseInt(val.retQty),
        pending_amount:parseFloat(sumDifference).toFixed(2),
        company_id: 1
      }
      arr.push(obj)
    }) 
    console.log(arr,'Vanthudu')
  setPostData((prevState) => ({...prevState , payment_details : arr,outstanding:resultValue,}))
  }
},[data,resultValue,sumRetQty,sumDifference])
console.log(sumDifference)
console.log(sumDifference)
console.log(selectedRows)
return (
    <Grid className="w-full h-full">
      <TableContainer className={classes.tblRoot}>
        <Table stickyHeader  className={classes.table}>
          <TableHead className={classes.tblHeader} sx={{position: "sticky",top: 0,}}>
            <TableRow className={classes.tablrow}>
              <TableCell className={classes.tblCell} sx={{borderLeft:'0.5px solid  #ccc'}}>Sno</TableCell>
              <TableCell className={classes.tblCell}>Bill No</TableCell>
              <TableCell className={classes.tblCell}>Bill Date</TableCell>
              <TableCell className={classes.tblCell}>Bill Amount</TableCell>
              <TableCell className={classes.tblCell}>OutStanding</TableCell>
              <TableCell className={classes.tblCell}>Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 ? _.map(data, (val, idx) => (
               <TableRow className={classes.tablrow} key={idx} onClick={() => getSelectedRow(idx)}>
               <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}><FormControlLabel label={idx+1} control={<Checkbox disabled={!val.retQty} defaultChecked onClick={() => handleCheckboxClick(val )}/>} /></TableCell>   
               <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}} >{val.docno}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{val.docdate}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{val.amount}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{val.outstanding}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>
               <TextField
                      // size="small"
                      // name="qty"
                      // value={editedQuantities[idx]}
                      // onChange={(e) => handleQtyChange(e.target.value, idx)}  
                      // autoComplete="off"
                      size="small"
                inputRef={qtyRef}
                value={val.retQty}
                onChange={handleQtyChange}
                    />
               </TableCell>
             </TableRow>
            )) : 
            
            <TableRow className={classes.tablrow}>
            <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}>{data.length + 1}</TableCell>
            <TableCell padding="checkbox" className={classes.tblContentCell}></TableCell>
             <TableCell  padding="checkbox" sx={{ width: 120 }}  className={classes.tblContentCell}></TableCell>
            <TableCell className={classes.tblContentCell} sx={{width:100}}></TableCell>
            <TableCell className={classes.tblContentCell} sx={{width:100}}></TableCell>
            <TableCell className={classes.tblContentCell} sx={{width:100}}></TableCell>
          </TableRow>
            }
              
          </TableBody>
        </Table>
      </TableContainer>
     
    </Grid>
  );
});

export default memo(BillingTable);
